import PrimitiveInput, {
  PrimitiveInputProps,
} from '@/components/form/_primitives/PrimitiveInput.tsx';
import React from 'react';
import InputError from '@/components/form/base/InputError.tsx';
import { cn } from '@/lib/utils.ts';

const TimeInput = (props: PrimitiveInputProps) => {
  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      <PrimitiveInput
        type="time"
        className={cn(
          'max-w-[105px] text-center',
          // '[&::-webkit-calendar-picker-indicator]:hidden',
          // '[&::-webkit-datetime-edit-fields-wrapper]:p-0',
        )}
        placeholder="HH:MM"
        {...props}
      />
      <InputError error={props.error} />
    </div>
  );
};

export default TimeInput;
